export const enCommon = {
  app: {
    name: "Olive UI",
    defaultDocumentTitle: "Olive UI",
    /** Helmet `titleTemplate`; `%s` is replaced with the page title. */
    titleTemplate: "%s · Olive UI",
  },
  nav: {
    logout: "Logout",
  },
  userMenu: {
    openAria: "Account menu",
    signedInAs: "Signed in as",
    profile: "My Profile",
    theme: "Theme",
    themeAria: "Select theme appearance",
    themeLight: "Light",
    themeDark: "Dark",
    themeSystem: "System",
  },
  sidebar: {
    ariaLabel: "Primary",
    brandName: "Olive",
    expand: "Expand sidebar",
    collapse: "Collapse sidebar",
    home: "Home",
    dataHub: "Data Hub",
    users: "Users",
    roles: "Roles",
    appStudio: "App Studio",
    nuggets: "Nuggets",
    chats: "Chats",
    apps: "Apps",
    actions: "Actions",
    newChat: "New Chat",
    settings: "Settings",
    tenants: "Tenants",
    contextHub: "Context Hub",
  },
  secondarySidebar: {
    ariaLabel: "Secondary",
    expand: "Expand secondary sidebar",
    collapse: "Collapse secondary sidebar",
  },
  env: {
    devBadge: "dev",
  },
  routes: {
    home: "Home",
    dataHub: "Data Hub",
    users: "Users",
    userProfile: "My Profile",
    roles: "Roles",
    appStudio: "App Studio",
    nuggets: "Nuggets",
    chat: "Ask Olive",
    chatHistory: "Chat History",
    apps: "Apps",
    actions: "Actions Hub",
    settings: "Settings",
    tenants: "Tenants",
    contextHub: "Context Hub",
  },
  errors: {
    boundaryTitle: "Something went wrong",
    reload: "Reload",
    apiTryAgain: "Something went wrong, try again",
  },
  loading: "Loading",
  bootstrap: {
    loadFailed: "Could not load tenant configuration.",
    retry: "Try again",
  },
  // Generic verbs shared across features via `useTranslation("common")`, distinct from each
  // feature's own `actions.*` block (new-entity buttons, etc.) which stays feature-scoped.
  actions: {
    close: "Close",
    cancel: "Cancel",
    back: "Back",
  },
} as const;
